function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.38833 8.1375C4.77824 6.95787 5.53072 5.93151 6.53843 5.20483C7.54614 4.47815 8.75761 4.08828 10 4.09083C11.4083 4.09083 12.6817 4.59083 13.6817 5.40917L16.5917 2.5C14.8183 0.954167 12.5458 0 10 0C6.05833 0 2.665 2.24833 1.03333 5.54167L4.38833 8.1375Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3667 15.0108C12.4583 15.5967 11.305 15.9092 10 15.9092C8.76256 15.9117 7.55567 15.525 6.55019 14.8036C5.54472 14.0823 4.79162 13.063 4.3975 11.89L1.03083 14.4458C1.85687 16.1178 3.13522 17.5245 4.72068 18.5063C6.30615 19.4881 8.13517 20.0056 10 20C12.4442 20 14.7792 19.1308 16.5283 17.5L13.3675 15.0108H13.3667Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5283 17.5C18.3575 15.7933 19.545 13.2533 19.545 9.99997C19.545 9.40831 19.4542 8.77247 19.3183 8.18164H10V12.0458H15.3633C15.0992 13.345 14.3883 14.3508 13.3675 15.0108L16.5283 17.5Z",
  fill: "#4A90E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.3975 11.89C4.19363 11.2807 4.09006 10.6424 4.09083 9.99996C4.09083 9.34829 4.195 8.72246 4.38833 8.13746L1.03333 5.54163C0.346979 6.9272 -0.00683247 8.45373 -2.13668e-06 9.99996C-2.13668e-06 11.6 0.370831 13.1083 1.03083 14.4458L4.3975 11.89Z",
  fill: "#FBBC05"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.84166662.svg";
export { ForwardRef as ReactComponent };